import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { MatRipple } from '@angular/material/core';
import { IconComponent } from '@libs/components/icons';
import { UserModel } from '@libs/account/models';

@Component({
  selector: 'ui-agent-bar',
  imports: [
    IconComponent,
    MatRipple,
  ],
  templateUrl: './agent-bar.component.html',
  styleUrl: './agent-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentBarComponent {
  public currentUser: InputSignal<UserModel> = input.required();
  public openSettings: OutputEmitterRef<void> = output();
}
